import { render, staticRenderFns } from "./OpenOrdersModal.vue?vue&type=template&id=5548f251&scoped=true&"
import script from "./OpenOrdersModal.vue?vue&type=script&lang=js&"
export * from "./OpenOrdersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5548f251",
  null
  
)

export default component.exports